var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"94%"},attrs:{"id":"map"}},[_c('sidebar-layers',{attrs:{"wsmlayers":_vm.wsmlayers},on:{"toggle-wms-layer":_vm.wmsLayerChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }